export const reportInventoriesTypes = {
  GET_REPORT_INVENTORIES: 'GET_REPORT_INVENTORIES',
  SET_REPORT_INVENTORIES_FILTERS: 'SET_REPORT_INVENTORIES_FILTERS',
  RESTORE_INITIAL: 'RESTORE_INITIAL',
};